import React, {Fragment, useState} from 'react';
import SingleChart from "./SingleChart";

const TreeChartView = (props) => {

  // const requestDataToShowDocumentDetails = (input) => {
  //   props.requestDataToShowDocumentDetails(input)
  // }
  return (
    <div>
      {
        props.treeChartData.map((v, index) => {
          return <Fragment key={index}>
            <SingleChart
              setReload={props.setReload}
              treeChartData={v}
              requestDataToShowDocumentDetails={props.requestDataToShowDocumentDetails}
              requestDataToShowMoein={props.requestDataToShowMoein}
              requestDataToEditeMoein={props.requestDataToEditeMoein}
              onClickJoinTitle={(lastTitle) => {
                let newTitle = "";

                if (lastTitle !== v.title) {
                  newTitle = v.title + "/ " + lastTitle
                } else {
                  newTitle = lastTitle
                }

                props.onClickJoinTitle(newTitle)
              }
              }

            />
          </Fragment>
        })
      }
    </div>
  );
}


export default TreeChartView;
